// FormPersistenceUtil.ts
import { ReviewFormData } from "@components/Forms/ReviewForm/ReviewForm";
import { QuestionFormData } from "@components/Forms/QuestionForm/QuestionForm";

// Ключи для localStorage
const REVIEW_FORM_KEY = "reviewFormData";
const QUESTION_FORM_KEY = "questionFormData";

export const FormPersistence = {
  // Функции для работы с данными формы отзыва
  saveReviewForm: (data: ReviewFormData, productId?: string): void => {
    try {
      const formData = {
        ...data,
        productId,
        timestamp: new Date().getTime(),
      };
      localStorage.setItem(REVIEW_FORM_KEY, JSON.stringify(formData));
    } catch (error) {
      console.error("Error saving review form data:", error);
    }
  },

  getReviewForm: (productId?: string): ReviewFormData | null => {
    try {
      const savedData = localStorage.getItem(REVIEW_FORM_KEY);
      if (!savedData) return null;

      const parsedData = JSON.parse(savedData);

      // Проверяем, соответствует ли данные текущему продукту
      if (productId && parsedData.productId !== productId) {
        return null;
      }

      return parsedData as ReviewFormData;
    } catch (error) {
      console.error("Error retrieving review form data:", error);
      return null;
    }
  },

  clearReviewForm: (): void => {
    try {
      localStorage.removeItem(REVIEW_FORM_KEY);
    } catch (error) {
      console.error("Error clearing review form data:", error);
    }
  },

  // Функции для работы с данными формы вопроса
  saveQuestionForm: (data: QuestionFormData, productId?: string): void => {
    try {
      const formData = {
        ...data,
        productId,
        timestamp: new Date().getTime(),
      };
      localStorage.setItem(QUESTION_FORM_KEY, JSON.stringify(formData));
    } catch (error) {
      console.error("Error saving question form data:", error);
    }
  },

  getQuestionForm: (productId?: string): QuestionFormData | null => {
    try {
      const savedData = localStorage.getItem(QUESTION_FORM_KEY);
      if (!savedData) return null;

      const parsedData = JSON.parse(savedData);

      // Проверяем, соответствует ли данные текущему продукту
      if (productId && parsedData.productId !== productId) {
        return null;
      }

      return parsedData as QuestionFormData;
    } catch (error) {
      console.error("Error retrieving question form data:", error);
      return null;
    }
  },

  clearQuestionForm: (): void => {
    try {
      localStorage.removeItem(QUESTION_FORM_KEY);
    } catch (error) {
      console.error("Error clearing question form data:", error);
    }
  },
};
